export default __webpack_public_path__ + "static/media/icons-send-and-receive.98cd9104.svg";